import { z } from "zod";

const BrowseRiskTypeSchema = z
  .object({
    search: z.string(),
    page: z.number().min(1, { message: "Page is out of bounds" }),
  })
  .strict();

export default BrowseRiskTypeSchema;
